import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import ModalCliente from '../../Cadastros/Cliente/ModalCliente/ModalCliente'
import useClienteInconsistencia, {
  LOAD_MESSAGE,
  MENU_ITEMS_NAMES,
  MODAL_NAME,
} from './ClienteInconsistenciaEnderecoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { Cnpj, CustomCheckbox, CustomPanel, PageHeader, ThreeDots } from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'

function ClienteInconsistenciaEndereco({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = useClienteInconsistencia()

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.LOADING_CUSTOMERS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCustomers()
        break

      case LOAD_MESSAGE.REMOVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteClientFromList(state.selectedClient.id)
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const buildDataTable = () => {
    const header = (
      <div style={{ textAlign: 'left' }}>
        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
        <InputText
          type="search"
          onInput={e => localDispatch.onInputFilter(e.target.value)}
          placeholder="Pesquisar . . ."
          size="50"
        />
      </div>
    )
    return (
      <DataTable
        value={state.customers}
        paginator={true}
        rows={10}
        header={header}
        globalFilter={state.globalFilter}
      >
        <Column field="nomeFantasia" header="Nome Fantasia" />
        <Column
          field="cnpj"
          header="CNPJ"
          body={(customer, column) => <Cnpj>{customer.cnpj}</Cnpj>}
        />
        <Column field="district" header="Bairro" />
        <Column field="city" header="Cidade" />
        <Column field="state" header="Estado" />
        <Column
          field="actived"
          header="Ativo"
          style={{ textAlign: 'center', width: 100 }}
          body={(rowData, column) => <CustomCheckbox disabled checked={rowData.actived} />}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={customer => (
            <ThreeDots
              items={MENU_ITEMS_NAMES}
              onClick={item => localDispatch.onMenuItemClicked(item, customer)}
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
    )
  }

  return (
    <div>
      <PageHeader>S.20 - Clientes com Inconsistência de Endereço</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={() => history.goBack()}>
          {buildDataTable()}
        </CustomPanel>
      </div>
      <ModalCliente
        show={localDispatch.modalIsOpen(MODAL_NAME.CUSTOMER)}
        onModalClose={localDispatch.closeModal}
        onModalSave={localDispatch.onModalClienteSave}
        selectedCliente={state.modalHandler.modalData}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ClienteInconsistenciaEndereco))
